import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=7fcc92be&scoped=true&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"
import style0 from "./Scholarship.vue?vue&type=style&index=0&id=7fcc92be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc92be",
  null
  
)

export default component.exports